import { Files, Network } from "../../.."
import store from "../../../../store"
import { formatDate } from "../../../formating"
import APIWrapper, { axiosWrapperV2 } from "../../APIWrapper"

// Replace enum with a plain object in JS
export const FundingFileStatus = {
	PROCESSED: "PROCESSED",
	PENDING: "PENDING"
}

export class FundingFileAttributes extends APIWrapper {
	constructor(attr) {
		super()
		Object.assign(this, attr)
	}
}

export class FundingFile extends FundingFileAttributes {
	static async getAll({ employerId }) {
		const data = await axiosWrapperV2
			.send({
				method: "GET",
				url: `employer/${employerId}/fundingFile`
			})
			.then((res) => res.data.data.map((f) => new this(f)))
		return data
	}

	static async upload({ employerId, files }) {
		const reports = await Promise.all(
			files?.map((file) =>
				Network.AxiosWrapperV2.upload(`employer/${employerId}/fundingFile`, file).then((res) => new this(res.data))
			)
		)
		store.setNotification("notification", true, {
			msg: `Uploaded plan funding file.`
		})
		return reports
	}

	get tableValues() {
		return {
			name: this.name,
			date: formatDate({
				data: this.createdTs,
				actions: ["display+time"]
			}),
			status: this.status.short,
			statusMessage: this.status.long
		}
	}

	async serve({ user }) {
		await Files.handleDownloadOrView({
			user,
			url: this.links.serve.url,
			name: this.file.name,
			type: this.file.mimeType,
			action: "download"
		})
		return this
	}

	async del() {
		if (this.links.delete) {
			await Network.AxiosWrapperV2.send(this.links.delete)
			store.setNotification("notification", true, {
				msg: `Deleted file ${this.name}.`
			})
			return this.id
		}
	}
}
